import React from 'react';
import { connect } from "react-redux";
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './Filter.scss';
import moment from "moment";

// @ts-ignore
import { currencyFormatter } from "@mooncake/utils";
import Loader from "../Loader/Loader";
import { fetchDisplayPrice, formatLocale, sendEvent } from '../../../utils';

interface IFilterProps {
  context?: IContent;
  loading?: any;
  products?: any;
  onlyCollectorEdition?: boolean;
  title?: string;
}

interface IFilterState {
  selectedEdition?: any;
  selectedVariant?: any;
}

class Filter extends React.Component<IFilterProps, IFilterState> {
  constructor(props: IFilterProps) {
    super(props);
    this.state = {
      selectedEdition: null,
      selectedVariant: null
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleSelectChange(e: any) {
    const { products } = this.props;
    this.setState({
      [e.target.name]: e.target.value
    });
    if (e.target.name === "selectedEdition") {
      const selectedVariant = products[e.target.value] ? products[e.target.value].originalData.variants[0].id : null;
      this.setState({
        selectedVariant
      })
    }
  }

  getVariationValue(variant: any, variationAttribute: any) {
    const valueVariationAttribute = variationAttribute.values.filter((objectVariationAttributeValue: any) => objectVariationAttributeValue.value === variant.variation_values[variationAttribute.id]);
    const valueToReturn = valueVariationAttribute.length === 1 ? valueVariationAttribute[0].description : null;
    return valueToReturn === "PS4" ? "PS4/PS5" : valueToReturn === "Xbox One" ? "Xbox One/Series X" : valueToReturn;
  }

  componentDidUpdate(prevProps: Readonly<IFilterProps>, prevState: Readonly<IFilterState>, snapshot?: any): void {
    const { context, products, onlyCollectorEdition } = this.props;
    const productsValues: any = Object.values(products);
    const { selectedEdition } = this.state;
    if (products !== prevProps.products && productsValues.length > 0 && selectedEdition !== productsValues[0].id) {
      const selectedEdition = onlyCollectorEdition ? context.collector_edition.id_product : productsValues[0].id;
      const selectedVariant = selectedEdition && products[selectedEdition] ? products[selectedEdition].originalData.variants[0].id : null;
      this.setState({
        selectedEdition,
        selectedVariant
      });
    }
  }

  render() {
    const { loading, products, context, onlyCollectorEdition, title } = this.props;
    const { collector_edition, global } = context;
    const { selectedEdition, selectedVariant } = this.state;
    let isProductsLoading = true;

    if (Object.keys(loading).length > 0) {
      isProductsLoading = Object.keys(loading).some((loadingKey: any) => loading[loadingKey]);
    }

    const productsValues = products ? Object.values(products).filter((product: any) => product.originalData.type.master) : [];

    const productsVariants = selectedEdition && products[selectedEdition] ? products[selectedEdition].originalData.variants : [];
    const variationAttributes = selectedEdition && products[selectedEdition] ? products[selectedEdition].originalData.variation_attributes : [];
    const selectedVariantFound = selectedEdition && selectedVariant && products[selectedEdition] ? products[selectedEdition].originalData.variants.filter((variant: any) => variant.id === selectedVariant) : [];

    // @ts-ignore
    const currency = window.GeoRestrictedResources ? window.GeoRestrictedResources.STOREFRONT_CURRENCY_CODE : null;
    // @ts-ignore
    const locale = window.GeoRestrictedResources ? formatLocale(window.GeoRestrictedResources.STOREFRONT_CURRENT_LOCALE) : null;
    // @ts-ignore
    const addProductUrl = window.Urls ? window.Urls.addProduct : null;

    const releaseDate = selectedEdition && selectedVariant && products[selectedEdition] ? products[selectedEdition].originalData.c_productReleaseDateTime : null;
    const preOrderable = releaseDate ? (releaseDate && moment(releaseDate) > moment()) : true;

    const displayPrice = selectedVariantFound.length === 1 ? fetchDisplayPrice(selectedVariantFound[0]) : null;

    const newPriceExists = selectedVariantFound.length === 1 && displayPrice.promotionalPrice && (typeof displayPrice.promotionalPrice === "number" || typeof displayPrice.promotionalPrice === "string");
    const oldPriceExists = selectedVariantFound.length === 1 && displayPrice.regular && (typeof displayPrice.regular === "number" || typeof displayPrice.regular === "string") && displayPrice.regular !== displayPrice.promotionalPrice;

    return (
      <div className="game-filters-container">
        {isProductsLoading ? (
          <Loader customColor="black" />
        ) : (
          <div className="game-filters">
            <div className="game-filters-title">{title}</div>
            <div className="filters-container-content">
              <label>
                <div className="game-filter-label">{collector_edition.edition}</div>
                {productsValues.length > 0 && (
                  <div className={`select-wrapper${onlyCollectorEdition ? " disabled" : ""}`}>
                    <select value={selectedEdition} disabled={onlyCollectorEdition} name="selectedEdition" onChange={(e) => this.handleSelectChange(e)}>
                      {productsValues.map((product: any, index: number) => (
                        <option value={product.id} key={index}>{product.name.edition}</option>
                      ))}
                    </select>
                  </div>
                )}
              </label>
              {variationAttributes.length > 0 && variationAttributes.map((variationAttribute: any, index: number) =>
                <label key={index}>
                  <div className="game-filter-label">{variationAttribute.name}</div>
                  <div className="select-wrapper">
                    <select value={selectedVariant} name="selectedVariant" onChange={(e) => this.handleSelectChange(e)}>
                      {productsVariants.filter((productVariant: any) => !!productVariant.variation_values[variationAttribute.id]).map((productVariant: any, index: number) => (
                        <option value={productVariant.id} key={index}>{this.getVariationValue(productVariant, variationAttribute)}</option>
                      ))}
                    </select>
                  </div>
                </label>
              )}
              {selectedVariantFound.length === 1 && (
                <div className="price-action">
                  <div className="price">
                    {newPriceExists && (
                      <div className={`new${oldPriceExists ? " with-old" : ""}`}>
                        {currencyFormatter(
                          displayPrice.promotionalPrice,
                          locale,
                          currency,
                          {
                            shouldKeepEmptyDecimals: false
                          }
                        )}
                      </div>
                    )}
                    {oldPriceExists && (
                      <div className="old">
                        {currencyFormatter(
                          displayPrice.regular,
                          locale,
                          currency,
                          {
                            shouldKeepEmptyDecimals: false
                          }
                        )}
                      </div>
                    )}
                  </div>
                  <div className="action">
                    <a
                      href={addProductUrl + "?pid=" + selectedVariantFound[0].id}
                      className={preOrderable ? "preorder" : "buynow"}
                      onClick={(e) => sendEvent(
                        `compare tab - add to cart - ${selectedVariantFound[0].variation_values.Platform} - far cry 6 - ${selectedVariantFound[0].c_productEditionString.toLowerCase()}`,
                        {
                          "PRODUCTID": selectedVariantFound[0].id,
                          "PRODUCTNAME": `${selectedVariantFound[0].variation_values.Platform} - far cry 6 - ${selectedVariantFound[0].c_productEditionString.toLowerCase()}`
                        })}
                    >
                      {preOrderable ? global.preorder : global.buy}
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  loading: state.app.loading,
  products: state.app.products
});

export default connect(mapStateToProps)(withContent(Filter));
